import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

/*PICTURE*/

const items = [
  {
    word: "Bisa diakses di Map Editor",
    image:
      "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_1.png",
    useZoom: true,
    zoomPosition: "bottom left",
    ending: "initial",
    delay: 6000,
  },
  {
    word: "Pada sidebar kanan pilih SINI",
    image:
      "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_2.png",
    useZoom: true,
    zoomPosition: "top right",
    ending: "initial",
    delay: 6000,
  },
  {
    word: "Site Selection dengan tampilan baru",
    image:
      "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_3.png",
    useZoom: true,
    zoomPosition: "top right",
    ending: "slide-to-top", // This item will now use the new animation
    delay: 6000, // Increased delay to accommodate the 3s slide
  },
  {
    word: "Data sebelumnya masih tersimpan di proyek Map History",
    image:
      "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_4.png",
    useZoom: true,
    zoomPosition: "top right",
    ending: "initial",
    delay: 6000,
  },
];

const initial_delay_ms = 2000;
const restart_delay_ms = 2000;
const zoom_out_delay_ms = 800; // Time for default zoom out transition
const slide_to_top_delay_ms = 2000; // NEW: Time for slide-to-top transition

const PARENT_INSIGHT = ({ auth }) => {
  const [step, setStep] = useState(0);
  const [word, setWord] = useState(
    "Insight berganti nama menjadi Site Selection"
  );
  const [image, setImage] = useState(
    "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_0.png"
  );
  const [useZoom, setUseZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState("");
  const [isZoomed, setIsZoomed] = useState(false);
  const [isSlidToTop, setIsSlidToTop] = useState(false); // NEW: State for slide animation

  const timeoutsRef = useRef(new Set());
  const isRunningRef = useRef(false);

  const clearAllTimeouts = () => {
    timeoutsRef.current.forEach((timeoutId) => {
      clearTimeout(timeoutId);
    });
    timeoutsRef.current.clear();
  };

  const createManagedTimeout = (callback, delay) => {
    const timeoutId = setTimeout(() => {
      timeoutsRef.current.delete(timeoutId);
      callback();
    }, delay);
    timeoutsRef.current.add(timeoutId);
    return timeoutId;
  };

  const resetToInitialState = () => {
    setStep(0);
    setWord("Insight telah berganti nama menjadi Site Selection");
    setImage(
      "https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/step_0.png"
    );
    setUseZoom(false);
    setZoomPosition("");
    setIsZoomed(false);
    setIsSlidToTop(false); // NEW: Reset slide state
  };

  useEffect(() => {
    setIsZoomed(false);

    if (useZoom) {
      const zoomTimeoutId = createManagedTimeout(() => {
        setIsZoomed(true);
      }, 1000);

      return () => clearTimeout(zoomTimeoutId);
    }
  }, [step, useZoom]);

  const startAnimation = () => {
    if (isRunningRef.current) {
      return;
    }

    isRunningRef.current = true;
    clearAllTimeouts();

    let currentIndex = 0;

    const processNextItem = () => {
      if (currentIndex >= items.length) {
        createManagedTimeout(() => {
          resetToInitialState();
          createManagedTimeout(() => {
            isRunningRef.current = false;
            startAnimation();
          }, restart_delay_ms);
        }, restart_delay_ms);
        return;
      }

      const item = items[currentIndex];

      // MODIFIED: Reset slide state for each new item
      setIsSlidToTop(false);

      setStep(currentIndex);
      setWord(item.word);
      setImage(item.image);
      setUseZoom(item.useZoom);
      setZoomPosition(item.zoomPosition);

      currentIndex++;

      // MODIFIED: Handle different ending animations and their durations
      if (item.useZoom) {
        const endTransitionDuration =
          item.ending === "slide-to-top"
            ? slide_to_top_delay_ms
            : zoom_out_delay_ms;

        const startEndAnimationDelay = item.delay - endTransitionDuration;

        createManagedTimeout(() => {
          if (item.ending === "slide-to-top") {
            setIsSlidToTop(true); // Trigger slide animation
          } else {
            setIsZoomed(false); // Trigger default zoom-out
          }
        }, startEndAnimationDelay);
      }

      createManagedTimeout(processNextItem, item.delay);
    };

    createManagedTimeout(processNextItem, initial_delay_ms);
  };

  useEffect(() => {
    startAnimation();
    return () => {
      clearAllTimeouts();
      isRunningRef.current = false;
    };
    // eslint-disable-next-line
  }, []);

  const getTransformOrigin = () => {
    switch (zoomPosition) {
      case "bottom left":
        return "bottom left";
      case "bottom right":
        return "bottom right";
      case "top left":
        return "top left";
      case "top right":
        return "top right";
      case "center":
        return "center center";
      default:
        return "center center";
    }
  };

  const imageContainerStyle = {
    overflow: "hidden",
    borderRadius: "8px",
    marginTop: "20px",
    width: "800px",
    maxWidth: "80vw",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    boxShadow:
      "0 20px 40px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.08)",
  };

  // MODIFIED: imageStyle is now more dynamic to handle slide-to-top
  const getDynamicImageStyle = () => {
    const scaleValue = useZoom && isZoomed ? 2 : 1;
    let translateY = "0%";

    if (isSlidToTop && useZoom) {
      // Calculate the height difference due to zoom
      const zoomedOutHeight = 100; // Assume initial height is 100%
      const zoomedInHeight = zoomedOutHeight * scaleValue;
      const heightDifference = zoomedInHeight - zoomedOutHeight;

      // Calculate the translateY value to align the bottom
      if (zoomPosition.startsWith("top")) {
        translateY = `-${heightDifference}px`;
      } else if (zoomPosition.startsWith("center")) {
        translateY = `-${heightDifference / 2}px`;
      }
      // If zoomPosition starts with "bottom", no translation needed
    } else if (isSlidToTop && !useZoom) {
      translateY = "-100%"; // Default slide to top if no zoom
    }

    return {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100%",
      height: "auto",
      transformOrigin: getTransformOrigin(),
      transition: `transform ${
        isSlidToTop ? `${slide_to_top_delay_ms}ms` : `${zoom_out_delay_ms}ms`
      } cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
      transform: `scale(${scaleValue}) translateY(${translateY})`,
      cursor: "pointer",
      borderRadius: "8px",
      objectFit: "contain",
      display: "block",
    };
  };

  return (
    <main
      className="main_container"
      style={{ minHeight: "90vh", textAlign: "center" }}
    >
      <div className="text_big margin_bottom_extra">{word}</div>
      <div style={imageContainerStyle}>
        <img
          key={`step-${step}`}
          alt={`step ${step + 1}`}
          src={image}
          style={getDynamicImageStyle()}
        />
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(PARENT_INSIGHT);
